import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { appLanguageSelector } from '../../../redux/app/selectors'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { varArgumentOptionsSelector } from '../selectors/selectors'
import { useFormulaOptions } from './useFormulaOptions'

export const useVarArguments = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const lng = useSelector(appLanguageSelector)
  const options = useFormulaOptions({
    companyId,
    lng,
    select: varArgumentOptionsSelector
  })
  return useQuery(options)
}
